module.exports = __webpack_public_path__ + "img/start@tab.fd012de0.webp";